import { TrainRoute } from "features/CenterContent/VehicleDetails/TrainDetails/useTrainRoute";
import { useTranslation } from "react-i18next";
import {
  HStack,
  Separator,
  Text,
  tokens,
  VStack,
} from "shared/components/Spor";
import { useTheme } from "styled-components";

type SwedishTrainNumbersProps = {
  train: TrainRoute;
};

export const SwedishTrainNumbers = ({ train }: SwedishTrainNumbersProps) => {
  const { t } = useTranslation();
  const theme = useTheme();
  return (
    <HStack
      border="1px solid"
      borderColor="outline.disabled"
      borderRadius="6px"
      padding={tokens.default.size.spacing[2]}
      gap={tokens.default.size.spacing[4]}
      marginLeft={tokens.default.size.spacing[4]}
      alignItems="stretch"
      separator={
        <Separator
          orientation="vertical"
          borderColor={theme.colorOutlineMain}
          borderLeftWidth="1px"
          height="auto"
        />
      }
    >
      <VStack alignItems="start" gap={tokens.default.size.spacing[1]}>
        {train.advertisedTrainNumber && (
          <>
            <Text variant="sm" fontWeight={700}>
              {t("Annonsert")}
            </Text>
            <Text variant="sm">{train.advertisedTrainNumber.identifier}</Text>
          </>
        )}
      </VStack>
      {train.operationalTrainNumbers.length > 0 && (
        <VStack alignItems="start" gap={tokens.default.size.spacing[1]}>
          <Text variant="sm" fontWeight={700}>
            {t("Operativt")}
          </Text>
          {train.operationalTrainNumbers.map((number) => (
            <Text key={number.identifier} variant="sm" color="text.highlight">
              {number.identifier} {`${number.origin} - ${number.destination}`}
            </Text>
          ))}
        </VStack>
      )}
    </HStack>
  );
};
